import React from 'react';
import { cn } from '@/lib/utils';

export type AlertBannerVariant = 'default' | 'destructive';

export interface AlertBannerProps {
  variant?: AlertBannerVariant;
  title?: string;
  children: React.ReactNode;
  /** Optional CTA (e.g. "Set baseline" button) */
  action?: React.ReactNode;
  className?: string;
}

const variantStyles: Record<AlertBannerVariant, string> = {
  default: 'border-l-primary/60 bg-primary/5',
  destructive: 'border-l-destructive/70 bg-destructive/5',
};

/**
 * Compact inline status/warning banner. Left severity accent, tight padding.
 */
export const AlertBanner: React.FC<AlertBannerProps> = ({
  variant = 'default',
  title,
  children,
  action,
  className,
}) => {
  return (
    <div
      role="alert"
      className={cn(
        'rounded-md border border-border border-l-[3px] py-2 px-3 text-xs',
        variantStyles[variant],
        className
      )}
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 min-w-0">
          {title != null && title !== '' && (
            <span className="font-semibold text-foreground shrink-0">{title}</span>
          )}
          <span className="text-muted-foreground truncate">{children}</span>
        </div>
        {action != null && <div className="shrink-0">{action}</div>}
      </div>
    </div>
  );
};

export default AlertBanner;
